/** @jsx jsx */
import { css, jsx } from "@emotion/core"

export function AnimatedChevron({
  dir,
  onClick,
  size = 32,
}: {
  dir: -1 | 0 | 1
  onClick?: () => void
  size?: number
}) {
  return (
    <div
      onClick={onClick}
      css={css`
        width: ${size}px;
        height: ${size}px;
        display: inline-block;
        vertical-align: middle;
      `}
    >
      <svg
        width={"100%"}
        height={"100%"}
        viewBox="0 0 100 100"
        css={css`
          ${!!onClick && "cursor: pointer;"}
          * {
            transition: 0.3s;
          }

          line {
            stroke: ${dir === 0 ? "#ccc" : "#333"};
            stroke-width: 10;
            stroke-linecap: round;
            transform-origin: 50px 50px;
          }

          ${dir === -1 &&
          css`
            g {
              transform: translate(0, 15%);
            }

            .line1 {
              transform: rotate(40deg);
            }

            .line2 {
              transform: rotate(-40deg);
            }
          `}
          ${dir === 1 &&
          css`
            g {
              transform: translate(0, -15%);
            }

            .line1 {
              transform: rotate(-40deg);
            }

            .line2 {
              transform: rotate(40deg);
            }
          `}
        `}
      >
        <g>
          <line className="line1" x1="10" y1="50" x2="50" y2="50" />
          <line className="line2" x1="90" y1="50" x2="50" y2="50" />
        </g>
      </svg>
    </div>
  )
}
